<script lang="ts">
    import cn from 'classnames';
    import {
        type ComponentProps,
        onDestroy,
        onMount,
        type SvelteComponent,
    } from 'svelte';

    import { EmbeddedDialogs } from '@components/layout/dialogs/components/embedded-dialogs';
    import { Container } from '@components/ui/container';
    import { dialogStore } from '@components/ui/dialog';
    import type { DialogStoreState } from '@components/ui/dialog/types';
    import { lockBodyScroll, unlockBodyScroll } from '@utils/body-scroll';

    import s from './dialogs.module.css';

    const getDialogProps = (state: DialogStoreState): ComponentProps<SvelteComponent> => {
        /* eslint-disable @typescript-eslint/no-unused-vars */
        const {
            containerClasses,
            containerWrapperClasses,
            backdropClasses,
            closeHandler,
            isBottomSheet,
            ...dialogProps
        } = state.props ?? {};
        /* eslint-enable @typescript-eslint/no-unused-vars */
        return dialogProps as ComponentProps<SvelteComponent>;
    };

    $: containerClasses = $dialogStore?.props?.containerClasses;
    $: containerWrapperClasses = $dialogStore?.props?.containerWrapperClasses;
    $: isBottomSheet = $dialogStore?.props?.isBottomSheet;
    $: backdropClasses = $dialogStore?.props?.backdropClasses;
    $: closeHanlderCustom = $dialogStore?.closeHandler;
    $: closeHandler = () => closeHanlderCustom ? closeHanlderCustom() : dialogStore.closeDialog();

    onMount(() => lockBodyScroll('dialogs'));
    onDestroy(() => {
        unlockBodyScroll('dialogs');
    });
</script>

<Container
    classes={cn({ [s.bottomSheet]: isBottomSheet }, s[`${containerWrapperClasses}`])}
    {closeHandler}
    backdropClasses={cn({ [s.bottomSheetBackdrop]: isBottomSheet }, s[`${backdropClasses}`])}
    closeByOutsideClick={$dialogStore.closeByOutsideClick}
    closeButtonClasses={cn({ [s.bottomSheetCloseButton]: isBottomSheet })}
    contentClasses={cn({ [s.bottomSheetContent]: isBottomSheet }, s[`${containerClasses}`])}
    testId='{$dialogStore.dialogType}-dialog'
    isHaveCloseBtn={$dialogStore.isHaveCloseBtn}
>
    {#if $dialogStore.dialogType}
        <EmbeddedDialogs dialogProps={getDialogProps($dialogStore)} dialogType={$dialogStore.dialogType} />
    {/if}
</Container>
